export type Spacing =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '8'
  | '10'
  | '12'
  | '16'
  | '20'
  | '24'
  | '28'
  | '32'
  | '36'
  | '40'
  | '48'
  | '56'
  | '64';

// Margin

export const mbVariants: Record<Spacing, string> = {
  '1': 'mb-1', // [4px]
  '2': 'mb-2', // [8px]
  '3': 'mb-3', // [12px]
  '4': 'mb-4', // [16px]
  '5': 'mb-5', // [20px]
  '6': 'mb-6', // [24px]
  '8': 'mb-8', // [32px]
  '10': 'mb-10', // [40px]
  '12': 'mb-12', // [48px]
  '16': 'mb-16', // [64px]
  '20': 'mb-20', // [80px]
  '24': 'mb-24', // [96px]
  '28': 'mb-28', // [112px]
  '32': 'mb-32', // [128px]
  '36': 'mb-36', // [144px]
  '40': 'mb-40', // [160px]
  '48': 'mb-48', // [192px]
  '56': 'mb-56', // [224px]
  '64': 'mb-64', // [256px]
};

export const mbTabletVariants: Record<Spacing, string> = {
  '1': 'md:mb-1', // [4px]
  '2': 'md:mb-2', // [8px]
  '3': 'md:mb-3', // [12px]
  '4': 'md:mb-4', //  [16px]
  '5': 'md:mb-5', // [20px]
  '6': 'md:mb-6', // [24px]
  '8': 'md:mb-8', // [32px]
  '10': 'md:mb-10', // [40px]
  '12': 'md:mb-12', // [48px]
  '16': 'md:mb-16', // [64px]
  '20': 'md:mb-20', // [80px]
  '24': 'md:mb-24', // [96px]
  '28': 'md:mb-28', // [112px]
  '32': 'md:mb-32', // [128px]
  '36': 'md:mb-36', // [144px]
  '40': 'md:mb-40', // [160px]
  '48': 'md:mb-48', // [192px]
  '56': 'md:mb-56', // [224px]
  '64': 'md:mb-64', // [256px]
};

export const mbDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:mb-1', // [4px]
  '2': 'lg:mb-2', // [8px]
  '3': 'lg:mb-3', // [12px]
  '4': 'lg:mb-4', //  [16px]
  '5': 'lg:mb-5', // [20px]
  '6': 'lg:mb-6', // [24px]
  '8': 'lg:mb-8', // [32px]
  '10': 'lg:mb-10', // [40px]
  '12': 'lg:mb-12', // [48px]
  '16': 'lg:mb-16', // [64px]
  '20': 'lg:mb-20', // [80px]
  '24': 'lg:mb-24', // [96px]
  '28': 'lg:mb-28', // [112px]
  '32': 'lg:mb-32', // [128px]
  '36': 'lg:mb-36', // [144px]
  '40': 'lg:mb-40', // [160px]
  '48': 'lg:mb-48', // [192px]
  '56': 'lg:mb-56', // [224px]
  '64': 'lg:mb-64', // [256px]
};

export const mtVariants: Record<Spacing, string> = {
  '1': 'mt-1', // [4px]
  '2': 'mt-2', // [8px]
  '3': 'mt-3', // [12px]
  '4': 'mt-4', // [16px]
  '5': 'mt-5', // [20px]
  '6': 'mt-6', // [24px]
  '8': 'mt-8', // [32px]
  '10': 'mt-10', // [40px]
  '12': 'mt-12', // [48px]
  '16': 'mt-16', // [64px]
  '20': 'mt-20', // [80px]
  '24': 'mt-24', // [96px]
  '28': 'mt-28', // [112px]
  '32': 'mt-32', // [128px]
  '36': 'mt-36', // [144px]
  '40': 'mt-40', // [160px]
  '48': 'mt-48', // [192px]
  '56': 'mt-56', // [224px]
  '64': 'mt-64', // [256px]
};

export const mtTabletVariants: Record<Spacing, string> = {
  '1': 'md:mt-1', // [4px]
  '2': 'md:mt-2', // [8px]
  '3': 'md:mt-3', // [12px]
  '4': 'md:mt-4', // [16px]
  '5': 'md:mt-5', // [20px]
  '6': 'md:mt-6', // [24px]
  '8': 'md:mt-8', // [32px]
  '10': 'md:mt-10', // [40px]
  '12': 'md:mt-12', // [48px]
  '16': 'md:mt-16', // [64px]
  '20': 'md:mt-20', // [80px]
  '24': 'md:mt-24', // [96px]
  '28': 'md:mt-28', // [112px]
  '32': 'md:mt-32', // [128px]
  '36': 'md:mt-36', // [144px]
  '40': 'md:mt-40', // [160px]
  '48': 'md:mt-48', // [192px]
  '56': 'md:mt-56', // [224px]
  '64': 'md:mt-64', // [256px]
};

export const mtDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:mt-1', // [4px]
  '2': 'lg:mt-2', // [8px]
  '3': 'lg:mt-3', // [12px]
  '4': 'lg:mt-4', // [16px]
  '5': 'lg:mt-5', // [20px]
  '6': 'lg:mt-6', // [24px]
  '8': 'lg:mt-8', // [32px]
  '10': 'lg:mt-10', // [40px]
  '12': 'lg:mt-12', // [48px]
  '16': 'lg:mt-16', // [64px]
  '20': 'lg:mt-20', // [80px]
  '24': 'lg:mt-24', // [96px]
  '28': 'lg:mt-28', // [112px]
  '32': 'lg:mt-32', // [128px]
  '36': 'lg:mt-36', // [144px]
  '40': 'lg:mt-40', // [160px]
  '48': 'lg:mt-48', // [192px]
  '56': 'lg:mt-56', // [224px]
  '64': 'lg:mt-64', // [256px]
};

export const negativeMlVariants: Record<Spacing, string> = {
  '1': '-ml-1', // [4px]
  '2': '-ml-2', // [8px]
  '3': '-ml-3', // [12px]
  '4': '-ml-4', // [16px]
  '5': '-ml-5', // [20px]
  '6': '-ml-6', // [24px]
  '8': '-ml-8', // [32px]
  '10': '-ml-10', // [40px]
  '12': '-ml-12', // [48px]
  '16': '-ml-16', // [64px]
  '20': '-ml-20', // [80px]
  '24': '-ml-24', // [96px]
  '28': '-ml-28', // [112px]
  '32': '-ml-32', // [128px]
  '36': '-ml-36', // [144px]
  '40': '-ml-40', // [160px]
  '48': '-ml-48', // [192px]
  '56': '-ml-56', // [224px]
  '64': '-ml-64', // [256px]
};

export const negativeMlTabletVariants: Record<Spacing, string> = {
  '1': 'md:-ml-1', // [4px]
  '2': 'md:-ml-2', // [8px]
  '3': 'md:-ml-3', // [12px]
  '4': 'md:-ml-4', // [16px]
  '5': 'md:-ml-5', // [20px]
  '6': 'md:-ml-6', // [24px]
  '8': 'md:-ml-8', // [32px]
  '10': 'md:-ml-10', // [40px]
  '12': 'md:-ml-12', // [48px]
  '16': 'md:-ml-16', // [64px]
  '20': 'md:-ml-20', // [80px]
  '24': 'md:-ml-24', // [96px]
  '28': 'md:-ml-28', // [112px]
  '32': 'md:-ml-32', // [128px]
  '36': 'md:-ml-36', // [144px]
  '40': 'md:-ml-40', // [160px]
  '48': 'md:-ml-48', // [192px]
  '56': 'md:-ml-56', // [224px]
  '64': 'md:-ml-64', // [256px]
};

export const negativeMlDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:-ml-1', // [4px]
  '2': 'lg:-ml-2', // [8px]
  '3': 'lg:-ml-3', // [12px]
  '4': 'lg:-ml-4', // [16px]
  '5': 'lg:-ml-5', // [20px]
  '6': 'lg:-ml-6', // [24px]
  '8': 'lg:-ml-8', // [32px]
  '10': 'lg:-ml-10', // [40px]
  '12': 'lg:-ml-12', // [48px]
  '16': 'lg:-ml-16', // [64px]
  '20': 'lg:-ml-20', // [80px]
  '24': 'lg:-ml-24', // [96px]
  '28': 'lg:-ml-28', // [112px]
  '32': 'lg:-ml-32', // [128px]
  '36': 'lg:-ml-36', // [144px]
  '40': 'lg:-ml-40', // [160px]
  '48': 'lg:-ml-48', // [192px]
  '56': 'lg:-ml-56', // [224px]
  '64': 'lg:-ml-64', // [256px]
};

// Padding

export const prMobileVariants: Record<Spacing, string> = {
  '1': 'pr-1', // [4px]
  '2': 'pr-2', // [8px]
  '3': 'pr-3', // [12px]
  '4': 'pr-4', // [16px]
  '5': 'pr-5', // [20px]
  '6': 'pr-6', // [24px]
  '8': 'pr-8', // [32px]
  '10': 'pr-10', // [40px]
  '12': 'pr-12', // [48px]
  '16': 'pr-16', // [64px]
  '20': 'pr-20', // [80px]
  '24': 'pr-24', // [96px]
  '28': 'pr-28', // [112px]
  '32': 'pr-32', // [128px]
  '36': 'pr-36', // [144px]
  '40': 'pr-40', // [160px]
  '48': 'pr-48', // [192px]
  '56': 'pr-56', // [224px]
  '64': 'pr-64', // [256px]
};

export const prTabletVariants: Record<Spacing, string> = {
  '1': 'md:pr-1', // [4px]
  '2': 'md:pr-2', // [8px]
  '3': 'md:pr-3', // [12px]
  '4': 'md:pr-4', // [16px]
  '5': 'md:pr-5', // [20px]
  '6': 'md:pr-6', // [24px]
  '8': 'md:pr-8', // [32px]
  '10': 'md:pr-10', // [40px]
  '12': 'md:pr-12', // [48px]
  '16': 'md:pr-16', // [64px]
  '20': 'md:pr-20', // [80px]
  '24': 'md:pr-24', // [96px]
  '28': 'md:pr-28', // [112px]
  '32': 'md:pr-32', // [128px]
  '36': 'md:pr-36', // [144px]
  '40': 'md:pr-40', // [160px]
  '48': 'md:pr-48', // [192px]
  '56': 'md:pr-56', // [224px]
  '64': 'md:pr-64', // [256px]
};

export const prDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:pr-1', // [4px]
  '2': 'lg:pr-2', // [8px]
  '3': 'lg:pr-3', // [12px]
  '4': 'lg:pr-4', // [16px]
  '5': 'lg:pr-5', // [20px]
  '6': 'lg:pr-6', // [24px]
  '8': 'lg:pr-8', // [32px]
  '10': 'lg:pr-10', // [40px]
  '12': 'lg:pr-12', // [48px]
  '16': 'lg:pr-16', // [64px]
  '20': 'lg:pr-20', // [80px]
  '24': 'lg:pr-24', // [96px]
  '28': 'lg:pr-28', // [112px]
  '32': 'lg:pr-32', // [128px]
  '36': 'lg:pr-36', // [144px]
  '40': 'lg:pr-40', // [160px]
  '48': 'lg:pr-48', // [192px]
  '56': 'lg:pr-56', // [224px]
  '64': 'lg:pr-64', // [256px]
};

export const plMobileVariants: Record<Spacing, string> = {
  '1': 'pl-1', // [4px]
  '2': 'pl-2', // [8px]
  '3': 'pl-3', // [12px]
  '4': 'pl-4', // [16px]
  '5': 'pl-5', // [20px]
  '6': 'pl-6', // [24px]
  '8': 'pl-8', // [32px]
  '10': 'pl-10', // [40px]
  '12': 'pl-12', // [48px]
  '16': 'pl-16', // [64px]
  '20': 'pl-20', // [80px]
  '24': 'pl-24', // [96px]
  '28': 'pl-28', // [112px]
  '32': 'pl-32', // [128px]
  '36': 'pl-36', // [144px]
  '40': 'pl-40', // [160px]
  '48': 'pl-48', // [192px]
  '56': 'pl-56', // [224px]
  '64': 'pl-64', // [256px]
};

export const plTabletVariants: Record<Spacing, string> = {
  '1': 'md:pl-1', // [4px]
  '2': 'md:pl-2', // [8px]
  '3': 'md:pl-3', // [12px]
  '4': 'md:pl-4', // [16px]
  '5': 'md:pl-5', // [20px]
  '6': 'md:pl-6', // [24px]
  '8': 'md:pl-8', // [32px]
  '10': 'md:pl-10', // [40px]
  '12': 'md:pl-12', // [48px]
  '16': 'md:pl-16', // [64px]
  '20': 'md:pl-20', // [80px]
  '24': 'md:pl-24', // [96px]
  '28': 'md:pl-28', // [112px]
  '32': 'md:pl-32', // [128px]
  '36': 'md:pl-36', // [144px]
  '40': 'md:pl-40', // [160px]
  '48': 'md:pl-48', // [192px]
  '56': 'md:pl-56', // [224px]
  '64': 'md:pl-64', // [256px]
};

export const plDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:pl-1', // [4px]
  '2': 'lg:pl-2', // [8px]
  '3': 'lg:pl-3', // [12px]
  '4': 'lg:pl-4', // [16px]
  '5': 'lg:pl-5', // [20px]
  '6': 'lg:pl-6', // [24px]
  '8': 'lg:pl-8', // [32px]
  '10': 'lg:pl-10', // [40px]
  '12': 'lg:pl-12', // [48px]
  '16': 'lg:pl-16', // [64px]
  '20': 'lg:pl-20', // [80px]
  '24': 'lg:pl-24', // [96px]
  '28': 'lg:pl-28', // [112px]
  '32': 'lg:pl-32', // [128px]
  '36': 'lg:pl-36', // [144px]
  '40': 'lg:pl-40', // [160px]
  '48': 'lg:pl-48', // [192px]
  '56': 'lg:pl-56', // [224px]
  '64': 'lg:pl-64', // [256px]
};

export const ptMobileVariants: Record<Spacing, string> = {
  '1': 'pt-1', // [4px]
  '2': 'pt-2', // [8px]
  '3': 'pt-3', // [12px]
  '4': 'pt-4', // [16px]
  '5': 'pt-5', // [20px]
  '6': 'pt-6', // [24px]
  '8': 'pt-8', // [32px]
  '10': 'pt-10', // [40px]
  '12': 'pt-12', // [48px]
  '16': 'pt-16', // [64px]
  '20': 'pt-20', // [80px]
  '24': 'pt-24', // [96px]
  '28': 'pt-28', // [112px]
  '32': 'pt-32', // [128px]
  '36': 'pt-36', // [144px]
  '40': 'pt-40', // [160px]
  '48': 'pt-48', // [192px]
  '56': 'pt-56', // [224px]
  '64': 'pt-64', // [256px]
};

export const ptTabletVariants: Record<Spacing, string> = {
  '1': 'md:pt-1', // [4px]
  '2': 'md:pt-2', // [8px]
  '3': 'md:pt-3', // [12px]
  '4': 'md:pt-4', // [16px]
  '5': 'md:pt-5', // [20px]
  '6': 'md:pt-6', // [24px]
  '8': 'md:pt-8', // [32px]
  '10': 'md:pt-10', // [40px]
  '12': 'md:pt-12', // [48px]
  '16': 'md:pt-16', // [64px]
  '20': 'md:pt-20', // [80px]
  '24': 'md:pt-24', // [96px]
  '28': 'md:pt-28', // [112px]
  '32': 'md:pt-32', // [128px]
  '36': 'md:pt-36', // [144px]
  '40': 'md:pt-40', // [160px]
  '48': 'md:pt-48', // [192px]
  '56': 'md:pt-56', // [224px]
  '64': 'md:pt-64', // [256px]
};

export const ptDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:pt-1', // [4px]
  '2': 'lg:pt-2', // [8px]
  '3': 'lg:pt-3', // [12px]
  '4': 'lg:pt-4', // [16px]
  '5': 'lg:pt-5', // [20px]
  '6': 'lg:pt-6', // [24px]
  '8': 'lg:pt-8', // [32px]
  '10': 'lg:pt-10', // [40px]
  '12': 'lg:pt-12', // [48px]
  '16': 'lg:pt-16', // [64px]
  '20': 'lg:pt-20', // [80px]
  '24': 'lg:pt-24', // [96px]
  '28': 'lg:pt-28', // [112px]
  '32': 'lg:pt-32', // [128px]
  '36': 'lg:pt-36', // [144px]
  '40': 'lg:pt-40', // [160px]
  '48': 'lg:pt-48', // [192px]
  '56': 'lg:pt-56', // [224px]
  '64': 'lg:pt-64', // [256px]
};

export const pbMobileVariants: Record<Spacing, string> = {
  '1': 'pb-1', // [4px]
  '2': 'pb-2', // [8px]
  '3': 'pb-3', // [12px]
  '4': 'pb-4', // [16px]
  '5': 'pb-5', // [20px]
  '6': 'pb-6', // [24px]
  '8': 'pb-8', // [32px]
  '10': 'pb-10', // [40px]
  '12': 'pb-12', // [48px]
  '16': 'pb-16', // [64px]
  '20': 'pb-20', // [80px]
  '24': 'pb-24', // [96px]
  '28': 'pb-28', // [112px]
  '32': 'pb-32', // [128px]
  '36': 'pb-36', // [144px]
  '40': 'pb-40', // [160px]
  '48': 'pb-48', // [192px]
  '56': 'pb-56', // [224px]
  '64': 'pb-64', // [256px]
};

export const pbTabletVariants: Record<Spacing, string> = {
  '1': 'md:pb-1', // [4px]
  '2': 'md:pb-2', // [8px]
  '3': 'md:pb-3', // [12px]
  '4': 'md:pb-4', // [16px]
  '5': 'md:pb-5', // [20px]
  '6': 'md:pb-6', // [24px]
  '8': 'md:pb-8', // [32px]
  '10': 'md:pb-10', // [40px]
  '12': 'md:pb-12', // [48px]
  '16': 'md:pb-16', // [64px]
  '20': 'md:pb-20', // [80px]
  '24': 'md:pb-24', // [96px]
  '28': 'md:pb-28', // [112px]
  '32': 'md:pb-32', // [128px]
  '36': 'md:pb-36', // [144px]
  '40': 'md:pb-40', // [160px]
  '48': 'md:pb-48', // [192px]
  '56': 'md:pb-56', // [224px]
  '64': 'md:pb-64', // [256px]
};

export const pbDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:pb-1', // [4px]
  '2': 'lg:pb-2', // [8px]
  '3': 'lg:pb-3', // [12px]
  '4': 'lg:pb-4', // [16px]
  '5': 'lg:pb-5', // [20px]
  '6': 'lg:pb-6', // [24px]
  '8': 'lg:pb-8', // [32px]
  '10': 'lg:pb-10', // [40px]
  '12': 'lg:pb-12', // [48px]
  '16': 'lg:pb-16', // [64px]
  '20': 'lg:pb-20', // [80px]
  '24': 'lg:pb-24', // [96px]
  '28': 'lg:pb-28', // [112px]
  '32': 'lg:pb-32', // [128px]
  '36': 'lg:pb-36', // [144px]
  '40': 'lg:pb-40', // [160px]
  '48': 'lg:pb-48', // [192px]
  '56': 'lg:pb-56', // [224px]
  '64': 'lg:pb-64', // [256px]
};

// gap

export const gapMobileVariants: Record<Spacing, string> = {
  '1': 'gap-1', // [4px]
  '2': 'gap-2', // [8px]
  '3': 'gap-3', // [12px]
  '4': 'gap-4', // [16px]
  '5': 'gap-5', // [20px]
  '6': 'gap-6', // [24px]
  '8': 'gap-8', // [32px]
  '10': 'gap-10', // [40px]
  '12': 'gap-12', // [48px]
  '16': 'gap-16', // [64px]
  '20': 'gap-20', // [80px]
  '24': 'gap-24', // [96px]
  '28': 'gap-28', // [112px]
  '32': 'gap-32', // [128px]
  '36': 'gap-36', // [144px]
  '40': 'gap-40', // [160px]
  '48': 'gap-48', // [192px]
  '56': 'gap-56', // [224px]
  '64': 'gap-64', // [256px]
};

export const gapTabletVariants: Record<Spacing, string> = {
  '1': 'md:gap-1', // [4px]
  '2': 'md:gap-2', // [8px]
  '3': 'md:gap-3', // [12px]
  '4': 'md:gap-4', // [16px]
  '5': 'md:gap-5', // [20px]
  '6': 'md:gap-6', // [24px]
  '8': 'md:gap-8', // [32px]
  '10': 'md:gap-10', // [40px]
  '12': 'md:gap-12', // [48px]
  '16': 'md:gap-16', // [64px]
  '20': 'md:gap-20', // [80px]
  '24': 'md:gap-24', // [96px]
  '28': 'md:gap-28', // [112px]
  '32': 'md:gap-32', // [128px]
  '36': 'md:gap-36', // [144px]
  '40': 'md:gap-40', // [160px]
  '48': 'md:gap-48', // [192px]
  '56': 'md:gap-56', // [224px]
  '64': 'md:gap-64', // [256px]
};

export const gapDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:gap-1', // [4px]
  '2': 'lg:gap-2', // [8px]
  '3': 'lg:gap-3', // [12px]
  '4': 'lg:gap-4', // [16px]
  '5': 'lg:gap-5', // [20px]
  '6': 'lg:gap-6', // [24px]
  '8': 'lg:gap-8', // [32px]
  '10': 'lg:gap-10', // [40px]
  '12': 'lg:gap-12', // [48px]
  '16': 'lg:gap-16', // [64px]
  '20': 'lg:gap-20', // [80px]
  '24': 'lg:gap-24', // [96px]
  '28': 'lg:gap-28', // [112px]
  '32': 'lg:gap-32', // [128px]
  '36': 'lg:gap-36', // [144px]
  '40': 'lg:gap-40', // [160px]
  '48': 'lg:gap-48', // [192px]
  '56': 'lg:gap-56', // [224px]
  '64': 'lg:gap-64', // [256px]
};

export const topNotchVariants: Record<Spacing, string> = {
  '1': '-mt-1', // [4px]
  '2': '-mt-2', // [8px]
  '3': '-mt-3', // [12px]
  '4': '-mt-4', //  [16px]
  '5': '-mt-5', // [20px]
  '6': '-mt-6', // [24px]
  '8': '-mt-8', // [32px]
  '10': '-mt-10', // [40px]
  '12': '-mt-12', // [48px]
  '16': '-mt-16', // [64px]
  '20': '-mt-20', // [80px]
  '24': '-mt-24', // [96px]
  '28': '-mt-28', // [112px]
  '32': '-mt-32', // [128px]
  '36': '-mt-36', // [144px]
  '40': '-mt-40', // [160px]
  '48': '-mt-48', // [192px]
  '56': '-mt-56', // [224px]
  '64': '-mt-64', // [256px]
};

export const topNotchTabletVariants: Record<Spacing, string> = {
  '1': 'md:-mt-1', // [4px]
  '2': 'md:-mt-2', // [8px]
  '3': 'md:-mt-3', // [12px]
  '4': 'md:-mt-4', //  [16px]
  '5': 'md:-mt-5', // [20px]
  '6': 'md:-mt-6', // [24px]
  '8': 'md:-mt-8', // [32px]
  '10': 'md:-mt-10', // [40px]
  '12': 'md:-mt-12', // [48px]
  '16': 'md:-mt-16', // [64px]
  '20': 'md:-mt-20', // [80px]
  '24': 'md:-mt-24', // [96px]
  '28': 'md:-mt-28', // [112px]
  '32': 'md:-mt-32', // [128px]
  '36': 'md:-mt-36', // [144px]
  '40': 'md:-mt-40', // [160px]
  '48': 'md:-mt-48', // [192px]
  '56': 'md:-mt-56', // [224px]
  '64': 'md:-mt-64', // [256px]
};

export const topNotchDesktopVariants: Record<Spacing, string> = {
  '1': 'lg:-mt-1', // [4px]
  '2': 'lg:-mt-2', // [8px]
  '3': 'lg:-mt-3', // [12px]
  '4': 'lg:-mt-4', //  [16px]
  '5': 'lg:-mt-5', // [20px]
  '6': 'lg:-mt-6', // [24px]
  '8': 'lg:-mt-8', // [32px]
  '10': 'lg:-mt-10', // [40px]
  '12': 'lg:-mt-12', // [48px]
  '16': 'lg:-mt-16', // [64px]
  '20': 'lg:-mt-20', // [80px]
  '24': 'lg:-mt-24', // [96px]
  '28': 'lg:-mt-28', // [112px]
  '32': 'lg:-mt-32', // [128px]
  '36': 'lg:-mt-36', // [144px]
  '40': 'lg:-mt-40', // [160px]
  '48': 'lg:-mt-48', // [192px]
  '56': 'lg:-mt-56', // [224px]
  '64': 'lg:-mt-64', // [256px]
};
